<template>
	<router-view :key="$route.fullPath" />
</template>
